<template>
  <div class="root-box consumable-page">
    <el-tabs v-model="activeTab">
      <el-tab-pane label="损耗件查询" name="query">
        <consumable-query ref="consumableQueryRef" />
      </el-tab-pane>
      <el-tab-pane label="车辆轮胎维护" name="tire">
        <tire-maintenance @success="onTireSuccess" />
      </el-tab-pane>
      <el-tab-pane label="车辆异常记录" name="anomaly">
        <vehicle-anomaly-record />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import ConsumableQuery from "./ConsumableQuery.vue";
import TireMaintenance from "./TireMaintenance.vue";
import VehicleAnomalyRecord from "./VehicleAnomalyRecord.vue";

export default {
  name: "VehicleConsumable",
  components: {
    ConsumableQuery,
    TireMaintenance,
    VehicleAnomalyRecord
  },
  data() {
    return {
      activeTab: "query"
    };
  },
  methods: {
    onTireSuccess() {
      this.activeTab = "query";
      this.$nextTick(() => {
        const ref = this.$refs.consumableQueryRef;
        if (ref && ref.queryList) {
          ref.queryList(1);
        }
      });
    }
  }
};
</script>

<style scoped>
.consumable-page {
  padding: 10px;
}
</style>
